export const getSubdomain = () => {
    
    let locationParts = window.location.hostname.split('.');

    let sliceTill = -2;

    const isLocalhost = locationParts.slice(-1)[0] === 'localhost';

    if (isLocalhost) {
        sliceTill = -1;

        return locationParts.slice(0, sliceTill).join("");
    }

    return locationParts[0];
}